import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="redirect-on-connect"
export default class extends Controller {
  static values = {
    path: String,
    error: String
  };

  connect() {
    let url = '';
    let redirect = '';
    if (this.hasPathValue) {
      if (this.pathValue.includes('https')) {
        url = new URL(this.pathValue);
        redirect = url;
      } else {
        url = new URL(window.location);
        redirect = `${url.origin}${this.pathValue}`;
      }
      if (this.hasErrorValue) {
        redirect += `?e=${this.errorValue}`;
      }
      window.location.replace(redirect);
    }
  }
}
